import { Observable, tap, map } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private themeLightIdent = 'theme-light';
  private themeDarkIdent = 'theme-dark';
  private currentTheme: string;

  constructor(private http: HttpClient) { }

  public initTheme(): Observable<void> {
    this.currentTheme = localStorage[environment.localStorageLastTheme] ?? this.themeLightIdent;
    return this.setTheme(this.currentTheme);
  }

  public toggleTheme()
  {
    if(this.currentTheme === this.themeLightIdent){
      this.currentTheme = this.themeDarkIdent;
    } else {
      this.currentTheme = this.themeLightIdent;
    }
    this.setTheme(this.currentTheme).subscribe();
  }

  private setTheme(themeName: string): Observable<void>
  {
    let url = "/" + themeName + ".css";
    return this.http.get(url, {responseType: 'text'}).pipe(
      tap((data => {
        localStorage[environment.localStorageLastTheme] = themeName;
        document.getElementById('theme').innerHTML = "/*" + themeName + "*/"+data;
      })),
      map(() => {})
    );
  }

}
